import type { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Modal from "../../../../../../components/base/Modal";
import { AvisoForm } from "../AvisoForm";
import type { AvisoFormData, ThemeClasses } from "../types";

interface AddAvisoModalProps {
  isDarkMode: boolean;
  themeClasses: ThemeClasses;
  form: UseFormReturn<AvisoFormData>;
  loadingSubmit: boolean;
  scopeLabel: string;
  scopeKind: "global" | "company";
  imagePreview: string | null;
  onImageChange: (file: File | null) => void;
  onClearImage: () => void;
  onClose: () => void;
  onSubmit: (data: AvisoFormData) => void;
}

export default function AddAvisoModal({
  isDarkMode,
  themeClasses,
  form,
  loadingSubmit,
  scopeLabel,
  scopeKind,
  imagePreview,
  onImageChange,
  onClearImage,
  onClose,
  onSubmit,
}: AddAvisoModalProps) {
  const { t } = useTranslation("adminSections");
  return (
    <Modal
      themeClasses={themeClasses}
      onClose={onClose}
      title={
        scopeKind === "global"
          ? t("avisos.newGlobalAviso")
          : t("avisos.newAviso")
      }
      content={
        <AvisoForm
          form={form}
          isEdit={false}
          loadingSubmit={loadingSubmit}
          themeClasses={themeClasses}
          isDarkMode={isDarkMode}
          scopeLabel={scopeLabel}
          scopeKind={scopeKind}
          imagePreview={imagePreview}
          onImageChange={onImageChange}
          onClearImage={onClearImage}
          onSubmit={onSubmit}
          onCancel={onClose}
        />
      }
    />
  );
}
